<template>
  <KycDesktop
    :ratio="1"
    :next-button-theme="nextButtonTheme"
    :title="$t('Last step')"
    back-route="/kyc/desktop/goal"
    @next="next"
  >
    <BaseSmallTitle class="mb-4">
      {{ $t('Documents') }}
    </BaseSmallTitle>
    <AttachmentContent />
  </KycDesktop>
</template>

<script>
import KycDesktop from '../Desktop.vue';
import BaseSmallTitle from '../../../components/BaseSmallTitle.vue';
import AttachmentContent from '../../partials/KycAttachmentContent.vue';
import kycAttachment from '../../../mixins/kycAttachment';
import kyc from '../../../mixins/kyc';

export default {
  name: 'Attachments',
  components: {
    KycDesktop,
    BaseSmallTitle,
    AttachmentContent,
  },
  mixins: [kycAttachment, kyc],
};
</script>
